import { Base } from "../../framework/base";
import { BaseFormModel, IBaseFormModel, IBaseSchemaParseResult } from "../common/baseFormModel";
import { TaskDataRowDataType } from "../enums";
import { ITaskDataRow, TaskDataRow } from "../task/taskDataRow";
import { TaskDataRowCol } from "../task/taskDataRowCol";
import { getSchemaObjectFromTaskTypeCol, ITaskTypeCol, TaskTypeCol, taskTypeColJsonSerializerReplacer } from "../task/taskTypeCol";

export interface IAppReportTemplateSchemaParseResult extends IBaseSchemaParseResult {
    appReportTemplate: IAppReportTemplateFormModel;
}

export const getAppReportTemplateFromSchema = (dataSchema: string, orgAppReportTemplate: IAppReportTemplateFormModel, orgFormDataRow: ITaskDataRow): IAppReportTemplateSchemaParseResult => {
    const result = AppReportTemplateFormModel.getAppReportTemplateSchemaParseResult(dataSchema);
    if (!result.appReportTemplate) {
        return {
            appReportTemplate: orgAppReportTemplate,
            formDataRow: orgFormDataRow,
            error: result.error,
        };
    }
    return result;
};

export interface IAppReportTemplateFormModel extends IBaseFormModel {
}

export const getSchemaFromAppReportTemplate = (appReportTemplate: IAppReportTemplateFormModel) => {
    const result = JSON.stringify(
        {
            form: Object.fromEntries(
                appReportTemplate?.formCols?.map(({ field, ...rest }) => [field, getSchemaObjectFromTaskTypeCol(rest)])
            ),
        },
        taskTypeColJsonSerializerReplacer,
        "\t"
    );
    return result;
};

export class AppReportTemplateFormModel extends BaseFormModel implements IAppReportTemplateFormModel {
    static getAppReportTemplateFormModelFromDataSchema(dataSchema: string, errorCallback: (error) => void): IAppReportTemplateFormModel {
        const result = new AppReportTemplateFormModel();
        if (!dataSchema) return result;
        try {
            const obj = JSON.parse(dataSchema);
            if (Base.isNullOrUndefined(obj)) return result;
            if (Object.prototype.hasOwnProperty.call(obj, "form") && !Base.isNullOrUndefined(obj.form)) {
                result.formCols = TaskTypeCol.getJsonTaskTypeColsFromJsonSchema(obj.form, false);
            }
        } catch (error) {
            errorCallback(error);
            return null;
        }
        return result;
    }

    static getAppReportTemplateSchemaParseResult = (dataSchema: string): IAppReportTemplateSchemaParseResult => {
        let dataSchemaParseError = "";
        const appReportTemplate = AppReportTemplateFormModel.getAppReportTemplateFormModelFromDataSchema(dataSchema, (error) => {
            dataSchemaParseError = Base.isString(error)
                ? (error ?? "")
                : (error.message && Base.isString(error.message)
                    ? error.message
                    : JSON.stringify(error));
        });
        if (!appReportTemplate) {
            return {
                appReportTemplate: null,
                formDataRow: null,
                error: dataSchemaParseError,
            };
        }
        const formDataRow = new TaskDataRow();
        formDataRow.id = Base.getGuid();
        formDataRow.cols = TaskDataRowCol.initializeValuesByType(appReportTemplate.formCols, []);
        return {
            appReportTemplate,
            formDataRow,
            error: dataSchemaParseError
        };
    };

    static getAppReportTemplateIdTitlesForUiSelect = (taskTypes: IAppReportTemplateFormModel[]) => {
        let result: { id: string, title: string, divider?: boolean }[] = [];
        if (taskTypes) {
            result = taskTypes.map(item => {
                return {
                    id: item.id,
                    title: item.code
                };
            });
        }
        return result;
    };

    static setTitlePageDataToFormDataRow = (formCols: ITaskTypeCol[], formDataRow: ITaskDataRow, startDate: number, endDate: number) => {
        if (!formDataRow || !formDataRow.cols || !formDataRow.cols.length) return;
        for (const col of formDataRow.cols) {
            const typeCol = formCols.find(c => c.field === col.field);
            if (typeCol.dataType !== TaskDataRowDataType.TitlePage &&
                typeCol.dataType !== TaskDataRowDataType.EventReference &&
                typeCol.dataType !== TaskDataRowDataType.TaskReference &&
                typeCol.dataType !== TaskDataRowDataType.RecordReference) continue;
            col.valueObj = {
                startDate,
                endDate,
            };
        }
    };
}